import React from "react";

import { useGetRootDevicesPagedLazyQuery, useGetRootDevicesPagedQuery } from "gql/generated/types";
import DevicesContent from "../components/Device/DevicesContent";

const Devices = () => (
  <DevicesContent
    tableName="Devices"
    useGetDevicesPagedLazyQuery={useGetRootDevicesPagedLazyQuery}
    useGetDevicesPagedQuery={useGetRootDevicesPagedQuery}
    dataKey="mdmRootDevicesByProjectIdPaged"
  />
);

export default Devices;
